import {SelectInput, SelectInputProps, useNotify, useResourceContext} from "react-admin";
import {useQuery} from "@tanstack/react-query";

export type ReferenceInputProps<TRecord> =
  Omit<SelectInputProps, "choices" | "isFetching" | "isLoading" | "isPending">
  & {
  choices: () => Promise<TRecord[]>;
}

export const ReferenceInput = <TRecord, >(props: ReferenceInputProps<TRecord>) => {
  const resources = useResourceContext({resource: props.resource});

  const notify = useNotify();

  const query = useQuery({
    queryKey: [resources, "list", "all", props.filter],
    queryFn: () => props.choices().catch((error) => {
      if (!error?.message) {
        console.error(error);
        return;
      }

      notify(error?.message, {type: "error"});
    }),
    // refetchOnMount: false,
    staleTime: 1000 * 60 * 15,
  });

  return (
    <SelectInput
      {...props}
      choices={query.data ?? undefined}
      isLoading={query.isLoading}
      isPending={query.isPending}
      isFetching={query.isFetching}
    />
  )
}